import { Record } from "../../components/record/Record";
import { Records } from "../../components/records/Records";
import { tabs } from "./bankTransactionsTabs";
import { DetailTabs } from "../../components/detailTabs/DetailTabs";
import { EntityForm } from "../../components/entityForm/EntityForm";
import { Groups } from "../../components/groups/Groups";
import { bankTransactionsOptions } from "./bankTransactionsOptions";
import { BankTransactionsListHeader } from "./BankTransactionsListHeader";
import { RecordsRelated } from "../../components/recordsRelated/RecordsRelated";
import { bankTransactionsOrdersPaymentsOptions, fieldsQuery as ordersPaymentsFieldsQuery } from "../orders/ordersPaymentsOptions";
import { BankTransactionDetailHeader } from "./BankTransactionDetailHeader";
import { OrderAssociateComponent } from "./OrdersAssociatedRecords/OrderAssociateComponent";
import { bankTransactionOperationalCentersOptions } from "../operational-centers/operationalCentersOptions";

const fieldsQuery = "*.*,category.*.*,orders.order_items.*";

export const bankTransactionsRoutes = [
    {
        path: "/bank_transactions",
        element: (
            <Records
                entity="bank_transactions"
                header={<BankTransactionsListHeader />}
                fieldsQuery={fieldsQuery}
                options={bankTransactionsOptions}
                heightOfHeaders={296}
            />
        ),
    },
    {
        path: "/bank_transactions/:id",
        element: (
            <Record
                entity="bank_transactions"
                type="detail"
                fieldsQuery={fieldsQuery}
                header={<BankTransactionDetailHeader />}
                body={<DetailTabs tabs={tabs} />}
            />
        ),
        children: [
            {
                path: "/bank_transactions/:id/detail",
                element: <Groups groupsOptions={bankTransactionsOptions.groupsOptions} />,
            },
            {
                element: (
                    <RecordsRelated
                        entity="orders_payments"
                        fieldsToQuery={ordersPaymentsFieldsQuery}
                        customFilter={(params) => {
                            return {
                                connected_bank_transaction_id: {
                                    _eq: params.parentId,
                                },
                            };
                        }}
                        recordsOptions={bankTransactionsOrdersPaymentsOptions}
                        customComponentHeader={<OrderAssociateComponent />}
                    />
                ),
                path: "/bank_transactions/:id/orders",
            },
            {
                element: (
                    <RecordsRelated
                        entity="operational_centers"
                        fieldsToQuery="*.*"
                        customFilter={(params) => {
                            return {
                                bank_transaction: {
                                    _eq: params.parentId,
                                },
                            };
                        }}
                        recordsOptions={bankTransactionOperationalCentersOptions}
                    />
                ),
                path: "/bank_transactions/:id/operational_centers",
            },
        ],
    },
    {
        path: "/bank_transactions/:id/update",
        element: (
            <Record
                entity="bank_transactions"
                type="update"
                fieldsQuery={fieldsQuery}
                body={<EntityForm groupsOptions={bankTransactionsOptions?.groupsOptions} />}
            />
        ),
    },
    {
        path: "/bank_transactions/create",
        element: (
            <Record
                entity="bank_transactions"
                type="create"
                fieldsQuery={fieldsQuery}
                body={<EntityForm groupsOptions={bankTransactionsOptions?.groupsOptions} />}
            />
        ),
    },
];
